import React from 'react';
import { useAppTranslation } from '../../../i18n';
import { Box, Typography } from '@mui/material';
import { CoffeeOutlined } from '../../svg/CoffeeOutlined';
import { useAppSelector } from '../../../app/hooks';
import { selectMaintenanceModeDetails } from '../../../app/slices/errors.slice';
import { format, parseISO } from 'date-fns';

interface MaintenanceModeDetails {
	maintenanceUntil: string | null;
	reason: string | null;
	status: string;
}

const TRANSLATION_PREXIX = 'steps.maintenance-mode';

// this link will get from response
const TEMPORARY_CHECK_STATUS_LINK = 'https://www.fincredible.io/status';

const MaintenanceMode = () => {
	const maintenanceModeDetails = useAppSelector(selectMaintenanceModeDetails) as MaintenanceModeDetails;
	const { t } = useAppTranslation();

	return (
		<Box className="maintenance-step">
			<Box className="maintenance-step-message">
				<CoffeeOutlined />
				<Box className="maintenance-step-title">
					<Typography
						component="h2"
						sx={{
							py: '28px',
							fontSize: '1.75rem',
							fontWeight: 'bold'
						}}
					>
						{t(`${TRANSLATION_PREXIX}.maintenance-mode-title`)}
					</Typography>
				</Box>
				<Box className="maintenance-step-header">
					<Typography sx={{ pb: 2 }}>{t(`${TRANSLATION_PREXIX}.maintenance-mode-header`)}</Typography>
				</Box>
				<Typography sx={{ pb: 5 }}>{t(`${TRANSLATION_PREXIX}.maintenance-mode-subheader`)}</Typography>
				{maintenanceModeDetails.maintenanceUntil && (
					<Typography sx={{ pb: 2 }}>
						{t(`${TRANSLATION_PREXIX}.maintenance-mode-due-date`)}:
						<b>{format(parseISO(maintenanceModeDetails.maintenanceUntil), 'dd.MM.yyyy HH:mm')}</b>
					</Typography>
				)}
				{maintenanceModeDetails.reason && (
					<Typography sx={{ pb: 2 }}>
						{t(`${TRANSLATION_PREXIX}.maintenance-mode-reason`)}: <b>{maintenanceModeDetails.reason}</b>
					</Typography>
				)}
				<Typography sx={{ overflowWrap: 'break-word' }}>
					{t(`${TRANSLATION_PREXIX}.maintenance-mode-check-status`)}:
					<a href={TEMPORARY_CHECK_STATUS_LINK} target="_blank">
						{TEMPORARY_CHECK_STATUS_LINK}
					</a>
				</Typography>
			</Box>
		</Box>
	);
};

export default MaintenanceMode;
